import type { LayoutResourceKey } from './layout';
import { layoutResources } from './layout';
import type { CommonResourceKey } from './common';
import { commonResources } from './common';
import type { AccountResourceKey } from './account';
import { accountResources } from './account';
import type { RegistrationResourceKey } from './registration';
import { registrationResources } from './registration';
import type { PartnerResourceKey } from './partner';
import { partnerResources } from './partner';
import type { FulfillmentResourceKey } from './fulfillment';
import { fulfillmentResources } from './fulfillment';
import type { ShipiumResourceKey } from './shipium_terms';
import { shipiumResources } from './shipium_terms';
import type { ReportResourceKey } from './reports';
import { reportResources } from './reports';
import type { ExceptionResourceKey } from './exception_management';
import { exceptionResources } from './exception_management';
import type { TrackingResourceKey } from './tracking';
import { trackingResources } from './tracking';
import type { SecurityResourceKey } from './security';
import { securityResources } from './security';
import type { RestrictionResourceKey } from './restriction';
import { restrictionResources } from './restriction';
import type { CarrierAccountResourceKey } from './carrier_account';
import { carrierAccountResources } from './carrier_account';
import type { LabelResourceKey } from './label';
import { labelResources } from './label';

export const ENResources: Record<ENResourceKey, string> = {
  ...commonResources,
  ...accountResources,
  ...layoutResources,
  ...registrationResources,
  ...partnerResources,
  ...fulfillmentResources,
  ...shipiumResources,
  ...reportResources,
  ...exceptionResources,
  ...trackingResources,
  ...securityResources,
  ...restrictionResources,
  ...carrierAccountResources,
  ...labelResources,
};
type ENResourceKey =
  | CarrierAccountResourceKey
  | RestrictionResourceKey
  | SecurityResourceKey
  | TrackingResourceKey
  | ExceptionResourceKey
  | ReportResourceKey
  | ShipiumResourceKey
  | FulfillmentResourceKey
  | AccountResourceKey
  | CommonResourceKey
  | LayoutResourceKey
  | RegistrationResourceKey
  | PartnerResourceKey
  | LabelResourceKey;
